module.exports = __webpack_public_path__ + "img/a6.6933b354.png";